import Constants from '../data/Constants';

const initialState = { alexState: 0 };

const alexReducer = (state = initialState, action) => {
  if (action.gameId !== Constants.GAME_ID) {
    return state;
  }

  switch (action.type) {
    case 'SET_ALEX_INACTIVE':
      return { ...state, alexState: Constants.ALEX_STATES.inactive };
    case 'SET_ALEX_ACTIVE':
      return { ...state, alexState: Constants.ALEX_STATES.active };
    case 'SET_ALEX_SPEAKING':
      return { ...state, alexState: Constants.ALEX_STATES.speaking };
    default:
      return state;
  }
};

export default alexReducer;
